import { useState } from "react";

interface TopBannerProps {
  color: string;
  text: string;
  title: string;
}



const TopBanner = ({ color, text, title }: TopBannerProps) => {
  const [show, setShow] = useState(true)
  return (
    (show && title != '' &&
      <div className={`py-2 px-4 ${color} w-100`}>
        <button type="button" className="position-absolute p-2 top-0 end-0 btn-close" aria-label="Close" onClick={() => setShow(false)} ></button>
        <div className="fs-6 fw-bold text-center">{title}</div>
        <div className="text-center">
          <span className="fs-7 lh-sm">{text}</span>
        </div>
      </div>
    )
  );
};

export default TopBanner;
